import { useState } from 'react';
import { BadgeDollarSign } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';

const today = () => new Date().toLocaleDateString('en-CA');

export const SoldVehicleButton = ({ vehicle, put, onDone }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(today());
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    const r = await put(`/fleet/vehicles/${vehicle.id}/sold`, { sold_date: date });
    setSaving(false);
    if (r.success) { toast.success(r.data.message); setOpen(false); onDone(); } else toast.error(r.error);
  };

  return (
    <>
      <button onClick={() => setOpen(true)} title="Marquer comme vendu"
        className="p-1.5 rounded hover:bg-slate-700 text-slate-400 hover:text-emerald-400 transition-colors" data-testid={`sold-vehicle-${vehicle.id}`}>
        <BadgeDollarSign size={16} />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-slate-900 border-slate-700 text-white max-w-sm" data-testid="sold-vehicle-dialog">
          <DialogHeader><DialogTitle>{vehicle.unit_number} vendu</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-400">
            Il disparaît de la flotte, d'Analytics et du choix des chauffeurs. Son historique (inspections, entretiens, bons) reste conservé pour la SAAQ.
          </p>
          <label className="text-xs text-slate-400 mt-2">Date de vente</label>
          <input type="date" value={date} max={today()} onChange={e => setDate(e.target.value)}
            className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white" data-testid="sold-vehicle-date" />
          <div className="flex justify-end gap-2 mt-3">
            <button onClick={() => setOpen(false)} className="px-3 py-2 rounded-lg text-sm text-slate-300 hover:bg-slate-800">Annuler</button>
            <button onClick={save} disabled={!date || saving} className="px-4 py-2 rounded-lg text-sm font-semibold bg-amber-500 text-black disabled:opacity-50" data-testid="sold-vehicle-confirm">
              Confirmer la vente
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
